import { useEffect } from "react";

export function useSEO({ title, description, canonical, ogTitle, ogDescription, ogUrl }) {
  useEffect(() => {
    // Title
    if (title) document.title = title;

    // Canonical
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    if (canonical) link.setAttribute("href", canonical);

    // Meta description
    let desc = document.querySelector('meta[name="description"]');
    if (desc && description) desc.setAttribute("content", description);

    // OG tags
    let ogT = document.querySelector('meta[property="og:title"]');
    if (ogT && ogTitle) ogT.setAttribute("content", ogTitle);

    let ogD = document.querySelector('meta[property="og:description"]');
    if (ogD && ogDescription) ogD.setAttribute("content", ogDescription);

    let ogU = document.querySelector('meta[property="og:url"]');
    if (ogU && ogUrl) ogU.setAttribute("content", ogUrl);

    return () => {
      // Reset to defaults on unmount
      document.title = "Stump Grinding Near Me | Stump Grinding Tucson AZ | Stump Removal Service";
    };
  }, [title, description, canonical, ogTitle, ogDescription, ogUrl]);
}
